export const notesAppPath = {
  home: '/',
  resgister: '/register',
  archives: '/archives',
  addNewPage: '/notes/new',
  detailPage: '/notes/:id',
  pageNotFound: '*',
};
